export const LOGO_URL = 'https://px-web-images8.pixpa.com/10SEJW4fqvAe438wAcqFaAyl5QlNR95ZAysKUqEeM_w/rs:fit:1000:0/q:80/czM6Ly9waXhwYS10ZXN0L2NvbS9sYXJnZS83OTUxNDcvNzk1MTQ3LTE3MjUzNjUyOTktamNjb29rcy1jYXRlcmluZy11cGRhdGVkLWxvZ28tc21sLnBuZw==';

export const HERO_IMAGES = [
  'https://public.readdy.ai/ai/img_res/63d4fe78549888b0a967b4c2b1eea7c1.jpg',
  'https://readdy.ai/api/search-image?query=magnificent%20wedding%20banquet%20reception%20hall%20luxury%20catering%20setup%20elegant%20white%20tablecloths%20towering%20floral%20centerpieces%20crystal%20chandeliers%20soft%20golden%20light%20sophisticated%20romantic%20atmosphere%20premium%20event&width=1920&height=1080&seq=hero_jc_2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=masterchef%20professional%20kitchen%20luxury%20fine%20dining%20chef%20plating%20exquisite%20gourmet%20dish%20marble%20countertop%20dramatic%20overhead%20spotlight%20stainless%20steel%20premium%20culinary%20art%20dramatic%20dark%20background&width=1920&height=1080&seq=hero_jc_3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=upscale%20outdoor%20catering%20event%20luxury%20garden%20dinner%20party%20string%20lights%20warm%20evening%20atmosphere%20elegant%20table%20setting%20premium%20catering%20service%20sophisticated%20al%20fresco%20dining%20beautiful%20natural%20light&width=1920&height=1080&seq=hero_jc_4&orientation=landscape',
];

export const CHEF_PHOTO = 'https://px-web-images8.pixpa.com/X4q9RdH6WZbHrfS-LluT8RCXVlUaGXrI-WBEzy8qspQ/rs:fit:500:0/q:80/czM6Ly9waXhwYS10ZXN0L2NvbS9sYXJnZS83OTUxNDcvNzk1MTQ3LTE3MjQxMTA1ODEtMjAyMDAzMjYtam95Y2VjdW5oYS00ODU5LXdlYnNpdGUtN2I4YWFlNjYuanBn';

export const FOOD_IMAGES = [
  'https://readdy.ai/api/search-image?query=exquisite%20private%20chef%20dinner%20elegant%20plated%20gourmet%20starter%20amuse%20bouche%20delicate%20portions%20white%20ceramic%20plate%20microgreens%20gold%20leaf%20element%20refined%20culinary%20artistry%20fine%20dining%20restaurant%20quality%20dramatic%20lighting&width=800&height=600&seq=food_jc_1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=lavish%20wedding%20catering%20display%20elegant%20buffet%20table%20luxury%20event%20food%20presentation%20tiered%20dessert%20tower%20champagne%20glasses%20beautiful%20floral%20garnish%20sophisticated%20catering%20service%20premium%20reception&width=800&height=600&seq=food_jc_2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=upscale%20corporate%20lunch%20catering%20executive%20boardroom%20elegant%20individual%20gourmet%20boxes%20premium%20ingredients%20beautifully%20plated%20professional%20business%20event%20sophisticated%20presentation%20artisan%20bread&width=800&height=600&seq=food_jc_3&orientation=landscape',
];

export const SECTION_IMAGES = {
  process: 'https://readdy.ai/api/search-image?query=professional%20personal%20chef%20preparing%20gourmet%20meal%20in%20elegant%20home%20kitchen%20luxury%20interior%20marble%20countertops%20beautiful%20light%20premium%20cookware%20artisan%20cooking%20craft%20attention%20to%20detail&width=1200&height=800&seq=process_jc&orientation=landscape',
  whyChoose: 'https://readdy.ai/api/search-image?query=accomplished%20female%20chef%20in%20professional%20whites%20holding%20elegant%20plated%20dish%20warm%20kitchen%20lighting%20confident%20expression%20culinary%20mastery%20premium%20restaurant%20quality%20sophisticated%20portrait&width=800&height=1000&seq=why_jc&orientation=portrait',
  cta1: 'https://readdy.ai/api/search-image?query=intimate%20luxury%20dinner%20table%20setting%20moody%20candlelight%20two%20place%20settings%20roses%20crystal%20wine%20glasses%20deep%20red%20atmosphere%20premium%20restaurant%20romantic%20evening%20refined%20elegant&width=1920&height=1080&seq=cta_jc_1&orientation=landscape',
  cta2: 'https://readdy.ai/api/search-image?query=stunning%20rooftop%20garden%20wedding%20reception%20luxury%20catering%20setup%20panoramic%20city%20view%20evening%20golden%20hour%20elegant%20table%20arrangements%20premium%20event%20venue%20sophisticated%20atmosphere&width=1920&height=1080&seq=cta_jc_2&orientation=landscape',
};

export const AWARDS_IMAGE = 'https://web-images.pixpa.com/vgGzTFQ0NczcjgHs1uTIw5at-h-PAQHsqDz1-XbRHzc/rs:fit:1200:0/q:90/aHR0cHM6Ly9zMy1pbWcucGl4cGEuY29tL2NvbS9sYXJnZS83OTUxNDcvNzk1MTQ3LTE3MjQxMjA0NDMtYXdhcmRzLnBuZw==';

export const BRAND = {
  name: 'JC Cooks Catering & Chef Service',
  shortName: 'JC Cooks',
  phone: '210-858-7293',
  phoneHref: 'tel:2108587293',
  email: 'info@jccooks.com',
  address: '7824 Mainland Drive, #106',
  city: 'San Antonio',
  state: 'Texas',
  zip: '78250',
  fullAddress: '7824 Mainland Drive, #106, San Antonio, Texas 78250',
  facebook: 'https://www.facebook.com/JCCOOKS.SA',
  twitter: 'https://twitter.com/jccooksgreat',
  linkedin: 'https://www.linkedin.com/in/joycecunha/',
  chef: 'Chef Joyce Cunha',
  experience: '20+',
};

export const SHARED_TRUST_STATS = [
  { value: '20+', label: 'Years of Mastery' },
  { value: '500+', label: 'Events Catered' },
  { value: '100+', label: 'Max Guest Count' },
  { value: '5★', label: 'Client-Rated' },
  { value: '100%', label: 'Scratch Cooked' },
];

export const SHARED_SERVICE_AREAS = [
  'San Antonio',
  'North San Antonio',
  'South San Antonio',
  'Leon Valley',
  'Helotes',
  'Converse',
  'Universal City',
  'Schertz',
  'New Braunfels',
  'Boerne',
];

export const SHARED_TESTIMONIALS = [
  {
    quote: 'Joyce... just have to say that the meals are absolutely delicious! We really like the stuffed chicken peppers and the chicken artichoke pasta meals. I still have quite a few meals left but may order sometime within the next week. We are trying to stay home and work from home.',
    author: 'Laura',
    context: 'Weekly Meal Client — San Antonio, TX',
    rating: 5,
  },
];

export const FORM_ACTION = 'https://readdy.ai/api/form/d7617cvlpdqvlupfpn80';
